import { render } from "./BoostItem.vue?vue&type=template&id=1b577ce6&scoped=true"
import script from "./BoostItem.vue?vue&type=script&lang=js"
export * from "./BoostItem.vue?vue&type=script&lang=js"

import "./BoostItem.vue?vue&type=style&index=0&id=1b577ce6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1b577ce6"

export default script